import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>
      <p>
        At <strong>Forever Speed Skating Academy</strong>, we are committed to protecting your privacy. This policy outlines how we collect, use, and safeguard your information when you interact with our website, registration forms, or services.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect personal information, including but not limited to:
      </p>
      <ul>
        <li>Full name, age, and contact details (email, phone number, address).</li>
        <li>Student details such as gender, DOB, and school name.</li>
        <li>Emergency contact and parent/guardian information.</li>
        <li>Photos or videos taken during sessions or events.</li>
        <li>Feedback, queries, or support interactions.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>
        The collected information is used to:
      </p>
      <ul>
        <li>Register students and manage their skating sessions.</li>
        <li>Provide updates, schedule changes, and important announcements.</li>
        <li>Promote events or achievements (only with permission).</li>
        <li>Enhance safety and operational efficiency.</li>
      </ul>

      <h2>3. Information Sharing</h2>
      <p>
        We do <strong>not</strong> sell or rent your personal data. However, we may share it:
      </p>
      <ul>
        <li>With our coaches/staff for training management.</li>
        <li>With event organizers or federations when participating in competitions.</li>
        <li>When required by law or regulatory authorities.</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We follow best practices to protect your data from unauthorized access, alteration, or misuse. Access to your information is limited to authorized staff only.
      </p>

      <h2>5. Your Rights</h2>
      <p>You may:</p>
      <ul>
        <li>Request to view, update, or delete your data at any time.</li>
        <li>Withdraw consent for photo or video sharing.</li>
        <li>Request clarification on how your data is used.</li>
      </ul>

      <h2>6. Photos & Media</h2>
      <p>
        We may occasionally capture photos or videos during training for educational or promotional purposes. You can opt out by informing us in writing.
      </p>

      <h2>7. Cookies (if applicable)</h2>
      <p>
        Our website may use cookies to enhance user experience and collect anonymous visitor data. You can manage cookies via your browser settings.
      </p>

      <h2>8. Policy Updates</h2>
      <p>
        We may revise this Privacy Policy from time to time. Any changes will be updated here with the revised date.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        For questions or privacy-related requests, please reach out at:
      </p>
      <ul>
        <li><strong>Email:</strong> fssacademy2020@gmail.com</li>
        <li><strong>Phone:</strong> +91 79775 63085</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
